<form [formGroup]="form">
    <ui-form-textarea
        class="mb-0"
        [placeholder]="'global.forms.labels.note' | translate"
        [label]="null"
        [formControlName]="abstractNoteFormField.Note" />

    <ui-dialog-actions>
        <ui-button
            [square]="true"
            [loading]="pending"
            [disabled]="form.status === 'INVALID' || pending"
            [label]="'global.actions.submit' | translate"
            (handlerClick)="handlerSubmit()" />
    </ui-dialog-actions>
</form>
